import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { outlineA11y, resetButton } from '@/css/resources/placeholders.css';
import { transitions, zIndex } from '@/css/resources/variables.css';

const getStyles = () =>
	css({
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: zIndex.modal,

		'.supt-modal__wrapper': {
			width: 'calc(100% - 45px * 2)',
			maxWidth: '940px',
		},

		'.supt-modal__inner': {
			position: 'relative',
			height: '50vh',
		},

		'.supt-modal__content': {
			height: '100%',
		},

		'.supt-modal__close': cssObj(resetButton, {
			position: 'absolute',
			fontSize: 0,
			zIndex: 2,
			top: '-40px',
			right: '-40px',
			width: '35px',
			height: '35px',
			transition: `transform ${transitions.fast}`,

			'&:hover, &:focus': {
				transform: 'scale(1.1)',
			},

			'html:not(.using-mouse) &:focus-within': outlineA11y,

			'&::before, &::after': {
				content: '""',
				position: 'absolute',
				height: '2px',
				width: '100%',
				top: '50%',
				left: 0,
				background: '#ffffff',
				marginTop: '-2px',
			},

			'&::before': {
				transform: 'rotate(45deg)',
			},

			'&::after': {
				transform: 'rotate(-45deg)',
			},
		}),
	});

export { getStyles };
